var i = /* @__PURE__ */ ((r) => (r.englishUS = "en-US", r.danish = "da", r.dutch = "nl", r.finnish = "fi", r.frenchFrance = "fr-FR", r.frenchCanada = "fr-CA", r.german = "de", r.italian = "it", r.norwegian = "no", r.portuguesePortugal = "pt-PT", r.portugueseBrazil = "pt-BR", r.spanish = "es", r.swedish = "sv", r.croatian = "hr", r.hungarian = "hu", r))(i || {});
export {
  i as GHLLanguageKeys
};
